import createTypography from '@mui/material/styles/createTypography';
import { newVyPalette } from './palette';

export const newVyTypography = createTypography(newVyPalette, {
  fontFamily: 'Inter, sans-serif',
  h1: {
    fontFamily: 'OakesGrotesk',
    marginBottom: '-4px',
  },
  h2: {
    fontFamily: 'OakesGrotesk',
    marginBottom: '-4px',
  },
  h3: {
    fontFamily: 'OakesGrotesk',
    marginBottom: '-4px',
  },
  h4: {
    fontFamily: 'OakesGrotesk',
    marginBottom: '-4px',
  },
  h5: {
    fontFamily: 'OakesGrotesk',
    marginBottom: '-4px',
  },
  h6: {
    fontFamily: 'OakesGrotesk',
    marginBottom: '-4px',
  },
});